/**
 * Directive: scheduleDisplay
 */
angular.module('acme.common.directive.scheduleDisplay', [
  'acme.common.service.calendar',
  'acme.common.directive.metaBlock',
  'acme.common.service.userPreferences'
])
.directive('scheduleDisplay', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/scheduleDisplay/scheduleDisplay.tpl.html',
      scope: {
        model: '='
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', '$filter', 'CalendarService', 'UserPreferencesService', function($scope, $filter, CalendarService, UserPreferencesService) {

        $scope.scheduleDisplay = {
          
          hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
          dateFormat: UserPreferencesService.getDateFormat('standardDateTime', 'dateFormat'),
          
          getTime: function(time) {
            return moment({ hours: time.hour, minutes: time.minutes}).format(this.hourFormat);
          },

          getDate: function(iso) {
            var r = false;

            if (iso) {
              r = $filter('date')(CalendarService.parseDate(iso), this.dateFormat);
            }

            return r;
          },

          getFormattedDays: function(days) {
            var r;

            if ($scope.model.repeatCycle === 'never') {
              r = 'One-time';
            }else{
              r = CalendarService.daysToString(days);
            }

            return r;
          }

        };

      }]

    };

}]);
